import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';
import type { ProfileResponse } from '@/types/auth';
import { getErrorMessage } from 'utils/error-message';

export const fetchProfile = createAsyncThunk<ProfileResponse, void, { rejectValue: string }>(
    'profile/fetchProfile',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get<ProfileResponse>('users/me');
            return {
                ...data,
                id: data.id ?? 'current-user',
                email: data.email ?? '',
                name: data.name ?? ''
            };
        } catch (error: unknown) {
            return rejectWithValue(getErrorMessage(error, 'Failed to fetch profile'));
        }
    }
);

export const setProfileDefaultHospital = createAsyncThunk<{ hospitalId: string }, { hospitalId: string }, { rejectValue: string }>(
    'profile/defaultHospital',
    async (hospitalObj, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post<{ hospitalId: string }>('users/default-hospital', hospitalObj);
            return data;
        } catch (error: unknown) {
            return rejectWithValue(getErrorMessage(error, 'Failed to fetch profile'));
        }
    }
);
